import { GraphApiMethod, GraphApiResponse } from '@/api/core';
import { HandleErrorInput, handleError } from '@/utils/custom';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { DeleteCombineRuleHistoryBulkDocument } from '@/api/queries';
import { DeleteCombineRuleHistoryInput } from '@/models/gen/graphql';
import graphApi from '@/api';

// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Delete Combine Rule Setting' } });

// Service Function Signature
type ServiceMethodPayload = string[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<GraphApiResponse>;
}

// DeleteCombineRuleHistoryBulk Service
export const { deleteCombineRuleHistoryBulk, useDeleteCombineRuleHistoryBulk } = ((): {
  deleteCombineRuleHistoryBulk: ServiceMethod;
  useDeleteCombineRuleHistoryBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(DeleteCombineRuleHistoryBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof DeleteCombineRuleHistoryBulkDocument>): ServiceMethod =>
      async (ids: ServiceMethodPayload): Promise<GraphApiResponse> => {
        const search: DeleteCombineRuleHistoryInput[] = ids.map((id: string): DeleteCombineRuleHistoryInput => ({ id }));
        const res = await fn({ input: { search } });
        return res;
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    deleteCombineRuleHistoryBulk: mutate,
    useDeleteCombineRuleHistoryBulk: useService,
  };
})();
